import { standardMeasurements } from './Base';

export const paddings = { ...standardMeasurements };

export type Padding = keyof typeof paddings;
